// Catálogos de Infoauto para personas (crearpersona / modifpersona /
// modiftelpersona). Los códigos son los que espera Infoauto; las descripciones
// son las de su catálogo.

// tipo_4 del teléfono. Por defecto 0 (No aplica).
export const PHONE_TYPES = [
  { value: 0, label: "N/A - No aplica" },
  { value: 1, label: "DOM - Domicilio" },
  { value: 2, label: "OFI - Oficina" },
  { value: 3, label: "MOV - Móvil" },
  { value: 4, label: "FAX - Fax" }
];

export const DEFAULT_PHONE_TYPE = 0;

// cod_area del teléfono: char(8) en Infoauto. Por defecto el prefijo del país
// de la tienda.
export const AREA_CODE_MAX_LENGTH = 8;

const DEFAULT_AREA_CODES = {
  nkr_usa: "+1",
  nkr_costa_rica: "+506",
  nkr_venezuela: "+58"
};

export function defaultAreaCode(storeCode) {
  return DEFAULT_AREA_CODES[storeCode] || "";
}

// tipo_documento de Costa Rica (código de hasta 4 caracteres). Por defecto
// vacío, igual que cod_actividad.
export const DOCUMENT_TYPES = [
  { value: "CE", label: "CE - Cédula de extranjería" },
  { value: "CI", label: "CI - Cédula Identidad" },
  { value: "EXND", label: "EXND - Extranjeros no domiciliados" },
  { value: "NCON", label: "NCON - No contribuyentes" },
  { value: "NIT", label: "NIT - Número de Ident. Fiscal" },
  { value: "PAS", label: "PAS - Pasaporte" }
];
